import React, { useState } from 'react';
import Benefits from './sections/Benefits/Benefits';
import Faq from './sections/Faq/Faq';
import Hero from './sections/Hero/Hero';
import Opinion from './sections/Opinion/Opinion';
import Phases from './sections/Phases/Phases';
import Sponsors from './sections/Sponsors/Sponsors';
import Timeline from './sections/Timeline/Timeline';
import styles from './WritingBee.module.scss'
import Helmet from 'react-helmet'
import AuthorCarrousel from './sections/AuthorCarrousel/AuthorCarrousel';
import AuthorResponsive from './sections/AuthorResponsive/AuthorResponsive';
import VideoPlayerModal from '../Structural/Modals/VideoPlayerModal';
import WinnersHero from './sections/WinnersHero/WinnersHero';

const WritingBee = () => {

  const [ showVideo, setShowVideo ] = useState(false)


  return (
    <main className={styles.handleMobile}>
      <Helmet>
        <title>Escribli Writing Bee | Escribli Writing Tools</title>
        <meta name="description" content="Register for the Escribli Writing Bee, a global writing competition for students. Registration starts in December and the winners are chosen in the spring! " />
        <meta name="keywords" content="writing bee, online school resources, resources for schools, educational resources online" />
        
      </Helmet>
      <WinnersHero />
      {/* <Hero setShowVideo={setShowVideo} /> */}
      <AuthorResponsive />
      <Sponsors />
      <AuthorCarrousel />
      <Timeline />
      <Phases />
      <Opinion />
      <Benefits />
      <Faq />

      {/* @todo update_video_link */}
      {showVideo && <VideoPlayerModal 
                      setShowVideo={setShowVideo} 
                      url={'https://www.youtube.com/watch?v=vxSTwXV_ITo&feature=youtu.be&ab_channel=Boomwriter'} 
                      height='428px'
                      width='760px' />
      }

    </main>
  );
}

export default WritingBee;